<template>
  <div>
    <SummaryEvent v-if="summary" :event="event" />

    <DetailEvent v-else :event="event" />
  </div>
</template>

<script>
import DetailEvent from '@/components/requests/overtime/timeline/DetailEvent'
import SummaryEvent from '@/components/requests/overtime/timeline/SummaryEvent'
import OvertimeCancelledEvent from '@/components/requests/overtime/events/OvertimeCancelledEvent'

export default {
  name: 'OvertimeWasCancelled',

  components: { SummaryEvent, DetailEvent },

  props: {
    event: {
      type: OvertimeCancelledEvent,
      required: true,
    },

    summary: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
